// extracted by mini-css-extract-plugin
export default {"formSubmit":"index_formSubmit_H2k-P","formSubmitSave":"index_formSubmitSave_CPA2N","formSubmitButton":"index_formSubmitButton_54RFY"};